import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { payrollHistoryTourSteps } from "./payrollHistoryTourSteps";

type PayrollHistoryTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string }) => void;
};

export function PayrollHistoryTour({ run, onCallback }: PayrollHistoryTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type });
  };

  return (
    <Joyride
      steps={payrollHistoryTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export { usePayrollHistoryTour } from "./usePayrollHistoryTour";
